export const GENERIC = `generic`;
export const GENERIC_DONE = `generic-done`;
export const CHECK_IN = `check-in`;
export const CHECK_OUT = `check-out`;
export const HATCH = `hatch`;
export const TRUCK = `truck`;
export const DELOREAN = `delorean`;

export const getPlantGraphic = () => {
    // Min = 0, max = 2
    switch(Math.floor(Math.random() * (2 - 0 + 1)) + 0) {
        case 0:
            return DELOREAN;
        case 1:
            return TRUCK;
        default:
            return HATCH;
    }
};



// WEBPACK FOOTER //
// ./scripts/constants/loading.js